/**
 * Cross-field rules for pricing insight columns on system_settings.
 */

export type PricingInsightToggleRow = {
  global_pricing_insight_enabled?: boolean | null;
  pricing_insight_enabled?: boolean | null;
  user_pricing_insight_enabled?: boolean | null;
  seller_price_band_enforcement_enabled?: boolean | null;
  seller_price_band_recommendation_chips_enabled?: boolean | null;
};

export function isSellerPriceBandEnforcementOperational(
  row: PricingInsightToggleRow,
): boolean {
  return (
    Boolean(row.seller_price_band_enforcement_enabled) &&
    Boolean(row.global_pricing_insight_enabled) &&
    Boolean(row.user_pricing_insight_enabled)
  );
}

/** Apply dependent turn-offs when a parent toggle is disabled. */
export function applyPricingInsightSettingsCascades(
  current: PricingInsightToggleRow,
  patch: Partial<PricingInsightToggleRow>,
): PricingInsightToggleRow {
  const merged: PricingInsightToggleRow = { ...current, ...patch };

  if (merged.global_pricing_insight_enabled === false) {
    merged.pricing_insight_enabled = false;
    merged.user_pricing_insight_enabled = false;
    merged.seller_price_band_enforcement_enabled = false;
    merged.seller_price_band_recommendation_chips_enabled = false;
  }

  if (merged.user_pricing_insight_enabled === false) {
    merged.seller_price_band_enforcement_enabled = false;
    merged.seller_price_band_recommendation_chips_enabled = false;
  }

  if (merged.seller_price_band_enforcement_enabled === false) {
    merged.seller_price_band_recommendation_chips_enabled = false;
  }

  return merged;
}

export function isSellerPriceBandRecommendationChipsOperational(
  row: PricingInsightToggleRow,
): boolean {
  return (
    isSellerPriceBandEnforcementOperational(row) &&
    Boolean(row.seller_price_band_recommendation_chips_enabled)
  );
}

export function validatePricingInsightSettings(
  row: PricingInsightToggleRow,
): string | null {
  if (
    row.seller_price_band_enforcement_enabled &&
    !row.global_pricing_insight_enabled
  ) {
    return "Seller price band enforcement requires Global Price Analysis to be enabled.";
  }
  if (
    row.seller_price_band_enforcement_enabled &&
    !row.user_pricing_insight_enabled
  ) {
    return "Seller price band enforcement requires User Price Assistant to be enabled.";
  }
  return null;
}
